<table
  aria-label="Codes"
  i18n-aria-label
  matSort
  mat-table
  [dataSource]="codes"
  [matSortActive]="sortColumnActive"
  [matSortDirection]="sortDirection"
  [matSortDisabled]="sortDisabled"
  [ngClass]="{ editable: editable, 'mtna-dense-table': editable }"
  [trackBy]="_trackByCode"
  (matSortChange)="_sortChange($event)"
>
  <ng-container matColumnDef="codeValue">
    <th mat-header-cell *matHeaderCellDef mat-sort-header i18n-sortActionDescription sortActionDescription="Sort by code value">
      <span i18n>Value</span>
    </th>
    <td class="no-wrap" mat-cell *matCellDef="let c; let index = index">
      <mtna-inline-editor [readonly]="!editable" (update)="updateCell($event, index, 'codeValue', c)">
        <ng-template mtnaViewMode>
          {{ c.codeValue }}
        </ng-template>
        <ng-template mtnaEditMode>
          <input mtnaFocusAfterViewInit [formControl]="(index | rdsGetFormArrayControl: _formArray:'codeValue')!" />
        </ng-template>
      </mtna-inline-editor>
    </td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="full-width">{{ _TEXT_name }}</th>
    <td mat-cell *matCellDef="let c; let index = index" class="code-name-cell">
      <mtna-inline-editor [readonly]="!editable" (update)="updateCell($event, index, 'name', c)">
        <ng-template mtnaViewMode>
          <span class="view-mode-container">{{ c.name }}</span>
        </ng-template>
        <ng-template mtnaEditMode>
          <input mtnaFocusAfterViewInit [formControl]="(index | rdsGetFormArrayControl: _formArray:'name')!" />
        </ng-template>
      </mtna-inline-editor>
    </td>
  </ng-container>

  <ng-content></ng-content>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator
  *ngIf="showPaginator"
  aria-label="Codes"
  i18n-aria-label
  [length]="length"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [pageSizeOptions]="[25, 50, 100]"
  (page)="pageChange.emit($event)"
></mat-paginator>
